import { create } from "zustand";
export var DropdownView;
(function (DropdownView) {
    DropdownView["ROOT"] = "ROOT";
    DropdownView["RECEIVE"] = "RECEIVE";
})(DropdownView || (DropdownView = {}));
const useDropdownStore = create((set, get) => ({
    view: DropdownView.ROOT,
    setView: (view) => set({ view }),
    isNestedView: () => get().view !== DropdownView.ROOT,
}));
export default useDropdownStore;
//# sourceMappingURL=dropdownStore.js.map